import React from "react";
import { AnimatePresence, motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { Scale, X } from "lucide-react";
import { useCompare } from "../context/CompareContext";
import { withImageFallback } from "../utility/imageFallback";
import Button from "./ui/Button";

const fallbackLogo = "/images/college-logo.jpeg";

const CompareTray = () => {
  const { selected, removeFromCompare, clearCompare } = useCompare();
  const navigate = useNavigate();

  const canCompare = selected.length >= 2;

  return (
    <AnimatePresence>
      {selected.length > 0 && (
        <motion.div
          initial={{ y: 80, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 80, opacity: 0 }}
          transition={{ duration: 0.25, ease: "easeOut" }}
          id="compare-tray"
          className="fixed bottom-0 left-0 right-0 z-40 border-t border-slate-200 bg-white/95 backdrop-blur shadow-elevated"
        >
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3 flex flex-wrap items-center gap-3">
            <div className="flex items-center gap-2 text-brand-700 font-semibold shrink-0">
              <Scale className="h-5 w-5" />
              Compare ({selected.length}/4)
            </div>

            <div className="flex flex-wrap items-center gap-2 flex-1 min-w-0">
              {selected.map((college) => (
                <div
                  key={college.id}
                  className="flex items-center gap-2 rounded-full border border-slate-200 bg-slate-50 pl-1 pr-2 py-1"
                >
                  <img
                    src={college?.collegeLogo && college.collegeLogo !== "N/A" ? college.collegeLogo : fallbackLogo}
                    onError={withImageFallback(fallbackLogo)}
                    alt={college.collegeName || "College"}
                    className="h-6 w-6 rounded-full object-contain bg-white"
                    loading="lazy"
                  />
                  <span className="text-xs font-medium text-slate-700 max-w-[10rem] truncate">
                    {college.collegeName || "College"}
                  </span>
                  <button
                    type="button"
                    aria-label={`Remove ${college.collegeName || "college"} from compare`}
                    onClick={() => removeFromCompare(college.id)}
                    className="text-slate-400 hover:text-rose-500"
                  >
                    <X className="h-3.5 w-3.5" />
                  </button>
                </div>
              ))}
            </div>

            <div className="flex items-center gap-3 shrink-0">
              <button
                type="button"
                onClick={clearCompare}
                className="text-sm font-medium text-slate-500 hover:text-slate-700"
              >
                Clear all
              </button>
              <Button
                type="button"
                variant="primary"
                disabled={!canCompare}
                onClick={() => canCompare && navigate(`/compare?ids=${selected.map((c) => c.id).join(",")}`)}
              >
                Compare Now
              </Button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CompareTray;
